<sim-select id="set-mode-select" [(value)]="propertyValue">
  <ng-container *ngFor="let option of options; let i = index">
    <sim-option id="set-mode-select-option-{{ i }}" [value]="option">{{ option }}</sim-option>
  </ng-container>
</sim-select>
